import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Products.css';
import { 
  FaLaptop, FaChild, FaWrench, FaHeartbeat, FaBlender, FaTshirt 
} from 'react-icons/fa';

const Sidebar = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const activeCategory = queryParams.get('productCategory');

  const categories = [
    { name: 'Electronics', icon: <FaLaptop /> },
    { name: 'Toys', icon: <FaChild /> },
    { name: 'Hardware', icon: <FaWrench /> },
    { name: 'Personal Care', icon: <FaHeartbeat /> },
    { name: 'Household Appliances', icon: <FaBlender /> },
    { name: 'Clothing Accessories', icon: <FaTshirt /> }
  ];

  return (
    <div className="sidebar">
      <ul>
        {categories.map((category) => {
          const isActive = activeCategory === category.name;
          return (
            <li key={category.name}>
              <Link 
                to={`/products?productCategory=${encodeURIComponent(category.name)}`}
                className={isActive ? 'active' : ''}
              >
                <div className="category-icon">{category.icon}</div>
                <span>{category.name}</span>
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default Sidebar;